import { render } from "./MainListUserAssists.vue?vue&type=template&id=6b9d3f6e&scoped=true"
import script from "./MainListUserAssists.vue?vue&type=script&lang=js"
export * from "./MainListUserAssists.vue?vue&type=script&lang=js"

import "./MainListUserAssists.vue?vue&type=style&index=0&id=6b9d3f6e&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9d3f6e"]])

export default __exports__